import { useState, useEffect, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";
import { requestUpdateManualTimeRequest } from "../../services/wisdomServices/requestService";
import { getPendingRequestsByManagerRequest } from "../../services/wisdomServices/managerService";
import { getSessionItem } from "../../utils/helper/session";
import { formatISOString } from "../../utils/helper/isoStringFormater";
import ManualTimesTable from "../../components/manualTimesTable/ManualTimesTable.jsx";

/**
 * @function ManualTimeApproval
 *
 * @param {Object} props 
 * @returns {JSX.Element} - manual time approval dashboard
 */
function ManualTimeApproval() {
  const date = new Date()
  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();
  const [month] = useState(currentMonth)
  const [year] = useState(currentYear)
  const toast = useRef(null);
  const [manualTimeRequests, setManualTimeRequests] = useState([]);
  const [loadingRequests, setLoadingRequests] = useState(true)
  let requestStatus = ["Requested", "Approved", "Rejected"];
  const user = getSessionItem("User");

  const storedProjects = JSON.parse(sessionStorage.getItem("projects") || "[]");
  
  const removeManualTimeFromList = (id) => {
    setManualTimeRequests((prev) =>
      prev.filter((item) => item.id !== id)
    );
  };

  const getManualTimes = useCallback(async (month, year) => {
    try {
      setLoadingRequests(true)
      const pendingRequests = await getPendingRequestsByManagerRequest("manualTime", month, year)
      const mapped = Array.isArray(pendingRequests)
        ? pendingRequests.map((mt) => ({
            id: mt.id,
            date: formatISOString(mt.date),
            name: mt.name,
            hours: mt.hours,
            project: mt.project,
            projectId: mt.projectId,
            reason: mt.reason,
            status: requestStatus[0],
            userId: mt.userId,
            approvalDate:
              mt.approvalDate == null
                ? ""
                : formatISOString(mt.approvalDate),
            type: "manualTime",
          }))
        : [];
  
      setManualTimeRequests(mapped);
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingRequests(false)
    }
  }, []);


  /**
   * @function ApproveRequest
   * @param {Object} row 
   * @description - approves a manual time request
   */
  const handleApproveRequest = async (row) => {
    try {
      let keys = {
        status: "approved"
      }
      await requestUpdateManualTimeRequest(row.userId, row.id, keys)

      removeManualTimeFromList(row.id);
    } catch (error) {
      console.error(error)
    }
  };

  const handleRejectRequest = async (row) => {
    try {
      removeManualTimeFromList(row);
    } catch (error) {
      console.error(error);
    }
  };



  const handleDateSelect = async(month, year) => {
    await getManualTimes(month, year)
  }



  useEffect(() => {
    let isCancelled = false;

    const loadData = async () => {
      try {
        getManualTimes(month, year)

        if (isCancelled) return; // Don't update state if component unmounted
      } catch (error) {
        console.error("[ManualTimeApproval] Failed to load data:", error);
      }
    };

    loadData();

    // Cleanup function to cancel updates after unmount
    return () => {
      isCancelled = true;
    };
  }, [getManualTimes]);

  if (!storedProjects || storedProjects.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#999", fontWeight: 400 }}>
          You don’t have any assigned projects yet to access <strong>Manual Time Approval</strong> page.
        </h1>
      </div>
    );
  }

  return (
    <div className="dashboardProjectsMain ManualTimeApproval">
      <Toast ref={toast} position="top-center" />
      <div>
        <h1 className="dashboardPayrollMain-header">
          Manual Time Approval
        </h1>
      </div>
      <div>
        <ManualTimesTable
          data={manualTimeRequests}
          loadingRequests={loadingRequests}
          onDateSelect={handleDateSelect}
          onApproveRequest={handleApproveRequest}
          onRejectRequest={handleRejectRequest}
        />
      </div>
    </div>
  );
}

export default ManualTimeApproval;
